const HELP_CENTER = {
    CONTENT_DETAIL: {
        COPY_LINK: {
            event: 'helpCenterContentDetailCopyLink',
            eventProperties: {
                contentId: '',
                contentType: '',
                description: 'Content detail page copy link',
                title: '',
            },
        },
        DOWNLOAD: {
            event: 'helpCenterContentDetailDownload',
            eventProperties: {
                contentId: '',
                contentType: '',
                description: 'Content detail page download',
                title: '',
            },
        },
        FAVORITE: {
            event: 'helpCenterContentDetailFavorite',
            eventProperties: {
                contentId: '',
                contentType: '',
                description: 'Content detail page favorite',
                title: '',
                value: '',
            },
        },
        LIKE_DISLIKE: {
            event: 'helpCenterContentDetailLikeDislike',
            eventProperties: {
                contentId: '',
                contentType: '',
                description: 'Content detail page Like/Dislike',
                title: '',
                value: '',
            },
        },
        PRINT: {
            event: 'helpCenterContentDetailPrint',
            eventProperties: {
                contentId: '',
                contentType: '',
                description: 'Content detail page print',
                title: '',
            },
        },
        VIEW: {
            event: 'helpCenterContentDetailView',
            eventProperties: {
                contentId: '',
                contentType: '',
                description: 'Content detail page view',
                feature: '',
                referrer: '',
                slug: '',
                title: '',
                url: '',
            },
        },
    },
};

export default HELP_CENTER;
